<template>
  <div id="wrap">
    <div class='main'>
      <div id="tabContent" :style="'height:'+screenHeight+'px'" class="tab-content">
        <!-- 图像部分 -->
        <div class="pictureBox" style="width:100%;height:100%;display:flex;justify-content:flex-start">
            <!--小图-->
          <div style="height:100%;width:140px;overflow:auto">
            <!-- <div class="csthumbnai" v-for="(item, index) in seriesList" @click="seriesSelect(index)" style="float:left"> -->
            <div class="csthumbnai" v-for="(item, index) in seriesList.instances" @click="showImg(index,0)">
            </div>
            
          </div>
          <!--大图-->
          <div class="bigImgBox" :style="'width:100%;height:100%;padding:0 5px;box-sizing:border-box'">
            <div v-for="imageViewport in imageViewports"
              class="viewportWrapper cornerstone-enabled-image"
              :style="{width: viewportWrapperWidth+'%',height: viewportWrapperHeight+'%'}"
              @contextmenu="returnFalse"
              unselectable='on'
              @selectstart='returnFalse' @mousedown='returnFalse'>

              <div v-show="!imageViewport.isShow" class="overlay overlay-text">Please drag a stack onto here to view images.</div>
              <div v-show="imageViewport.isShow" class="viewport" oncontextmenu="return false">
                  <!-- 四角标注 -->
                  <!-- 左上 -->
                  <div class="setupViewportOverlays" style="top: 5px;left: 5px;">
                    <div>{{imageViewport.x00181151}}</div>
                    <div>{{imageViewport.x00180050}}</div>
                  </div>
                  <!-- 右上 -->
                  <div class="setupViewportOverlays" style="top: 5px; right: 5px">
                    <div>{{imageViewport.x00180060}}</div>
                    <div>{{imageViewport.FPS}}</div>
                  </div>
                  <!-- 左下 -->
                  <div class="setupViewportOverlays" style="bottom: 10px; left: 5px">
                    <div class="fps">{{imageViewport.FPS}}</div>
                    <div class="renderTime">{{imageViewport.RenderTime}}</div>
                    <div class="currentImageAndTotalImages">{{imageViewport.Image}}</div>
                  </div>
                  <!-- 右下 -->
                  <div class="setupViewportOverlays" style="bottom: 10px; right: 5px">
                    <div>{{imageViewport.Zoom}}</div>
                    <div>{{imageViewport.WWWL}}</div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        

      </div>
    </div>
  </div> 
</template>

<script>


  import * as cornerstone from "../../../static/dist/cornerstone.js";
  import * as dicomParser from "../../../static/dist/dicomParser.js"
  
  
  import * as cornerstoneWADOImageLoader from "../../../static/dist/cornerstoneWADOImageLoader.js";
 
 
  import Hammer from "../../../static/dist/hammer.js";
  import * as cornerstoneMath from "../../../static/dist/cornerstoneMath.js";
  import * as cornerstoneTools from "../../../static/dist/cornerstoneTools.js";
  
  cornerstoneTools.external.Hammer = Hammer;
  cornerstoneTools.external.cornerstone = cornerstone;
  cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
  cornerstoneWADOImageLoader.external.cornerstoneMath = cornerstoneMath;
  cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
  
  cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
  cornerstone.registerImageLoader("http", cornerstoneWADOImageLoader.loadImage);
  cornerstone.registerImageLoader("https", cornerstoneWADOImageLoader.loadImage);

  //配置 webWorker (必须配置)
  //注意这里的路径问题  如果路径不对 cornerstoneWADOImageLoaderWebWorker 会报错 index.html Uncaught SyntaxError: Unexpected token <
  // var config = {
  //   webWorkerPath: "../../../static/dist/cornerstoneWADOImageLoaderWebWorker.js",
  //   taskConfiguration: {
  //     decodeTask: {
  //       codecsPath: "../../../static/dist/cornerstoneWADOImageLoaderCodecs.js"
  //     }
  //   }
  // };
  // cornerstoneWADOImageLoader.webWorkerManager.initialize(config);


  export default {
    name: "ViewmUlti",
    data() {
      return {
        screenHeight: document.documentElement.clientHeight,//视口高度
        screenWidth: document.documentElement.clientWidth-130,//视口宽度（即大图宽度，视口宽度-小图占据宽度）
        // baseUrl: "https://new-yingxiang.oss-cn-beijing.aliyuncs.com/",//dicom-store存储dicom文件的位置（改变时，修改dicom-store）
        baseUrl: "https://yx.huayiyun.net/oss/",//dicom-store存储dicom文件的位置（改变时，修改dicom-store）
        // baseUrl: "",//dicom-store存储dicom文件的位置（改变时，修改dicom-store）
        seriesList: "", //包含序列信息的图像集，从后台获取
        isInitLoad: true,// ？？
        isShow: true,
        synchronizer: new cornerstoneTools.Synchronizer("cornerstonenewimage", cornerstoneTools.updateImageSynchronizer),
        layoutVal: '1x1',//选择的大图布局值
        //影像片子序列
        imageViewports: [
          {
            isShow: true,
            isEnable: false,
            isSetupViewportOverlays: false,
            isLoadAndCacheImage: false
          }
        ],
        //大图大小占比
        viewportWrapperWidth: 100,
        viewportWrapperHeight: 100
      }
    },
    mounted() {

      // 然后监听window的resize事件
      const that = this;
      window.onresize = () => {
        return (() => {
          that.screenHeight = document.documentElement.clientHeight;
          that.screenWidth = document.documentElement.clientWidth-150;
        })()
      }
      this.seriesList=this.$common.getStorage('imageList');
      console.log(this.seriesList)
			console.log('xxxx')
      //展示图像
      this.show();
    },
    methods: {
      returnFalse() {
        return false;
      },
      //图像初始化
      show() {
        var _this=this;
        this.$nextTick(() => {
          var csthumbnais = document.getElementsByClassName("csthumbnai");
          for (var i = 0; i < csthumbnais.length; i++) {
            let canvas = csthumbnais[i];

            cornerstone.enable(canvas);

            let imageUrl = this.baseUrl+this.seriesList.instances[i].dicomUrl;
            let imageId = "wadouri:" + imageUrl;
            //  Load & Display
            cornerstone.loadAndCacheImage(imageId).then(
              function (image) {
                // console.log(image);
                // 设置元素视口
                var viewport = cornerstone.getDefaultViewportForImage(
                  canvas,
                  image
                );
                // 显示图像
                cornerstone.displayImage(canvas, image, viewport);
                _this.restore();
              },
              function (err) {
                console.log('%c '+err,'color:red');
              }
            );
          }
          // let canvas = document.getElementsByClassName("viewport")[0];
          // console.log(canvas);
          // 在 DOM 中将 canvas 元素注册到 cornerstone
          // cornerstone.enable(canvas);
          //四角标注
          // _this.setupViewportOverlays(canvas)
          //选择序列
          this.seriesSelect(0);
        })
        this.listenForWindowResize();
      },
      
      //展示某一个图像(index-展示的序列下标，num-展示在下标为num的大图中)
      showImg(index,num){
		  
          //dom加载完成后，加载图像
          this.$nextTick(() => {
              this.imageViewports[num].isShow = true;//有图显示四角标注
              let canvass = document.getElementsByClassName("viewportWrapper");//大图dom
              this.imageViewports[num].isLoadAndCacheImage = false;

              //（避免重复赋值，每次赋值结果一样）
              if( !this.imageViewports[num].canvas){
                  this.imageViewports[num].canvas = canvass[num].getElementsByClassName("viewport")[0];
              }
              if (!this.imageViewports[num].isEnable) {
                  cornerstone.enable(this.imageViewports[num].canvas);
                  this.imageViewports[num].isEnable = true;
              }
              if (!this.imageViewports[num].isSetupViewportOverlays) {
                  //四角标注
                  this.setupViewportOverlays(num)
                  this.imageViewports[num].isSetupViewportOverlays = true;
              }

              // 拼接 url : cornerstoneWADOImageLoader 需要 wadouri 路径头
              const imageUrl = this.baseUrl + this.seriesList.instances[index].dicomUrl;
              let imageId = "wadouri:" + imageUrl;

              // 下载图像并显示
              var that=this;
              cornerstone.loadAndCacheImage(imageId).then(
                  function (image) {
                      // 设置元素视口
                      let viewport = cornerstone.getDefaultViewportForImage(
                          that.imageViewports[num].canvas,
                          image
                      );
                      // 激活工具(图像加载前，初始化工具)
                      that.initCanvasTools1(index, num);
                      // 显示图像
                      cornerstone.displayImage(that.imageViewports[num].canvas, image, viewport);
                      // 激活工具(图像加载后，初始化工具)
                      that.initCanvasTools2(index, num);
                      
                      // 判断图像是否加载完成
                      if (!that.imageViewports[num].isLoadAndCacheImage) {
                          that.imageViewports[num].isLoadAndCacheImage = true;
                          cornerstone.resize(that.imageViewports[num].canvas, true);
                          that.restore();
                      }
                  },
                  function (err) {
                      console.log('%c '+err,'color:red');
                  }
              );
          }) 
          // Dicom 加载 进度
          cornerstone.events.addEventListener(
            "cornerstoneimageloadprogress",
            function (event) {
              const eventData = event.detail;
              const loadProgress = document.getElementById("loadProgress");
            }
          );
      },
      //选择序列
      seriesSelect(seriesNum) {
        //添加小图选中样式
        let csthumbnais = document.getElementsByClassName("csthumbnai");
        for (var i = 0; i < csthumbnais.length; i++) {
            csthumbnais[i].classList.remove('selected');
        }
        csthumbnais[seriesNum].classList.add('selected')

        var _this = this;
        //dom加载完成后，加载图像
        this.$nextTick(() => {
            // 找到要渲染的元素
            let canvass = document.getElementsByClassName("viewportWrapper");
            _this.imageViewports[0].isLoadAndCacheImage = false;

            //避免重复赋值，每次赋值结果一样
            if( !_this.imageViewports[0].canvas){
              _this.imageViewports[0].canvas = canvass[0].getElementsByClassName("viewport")[0];
            }
            if (!_this.imageViewports[0].isEnable) {
              cornerstone.enable(_this.imageViewports[0].canvas);
              _this.imageViewports[0].isEnable = true;
            }
            if (!_this.imageViewports[0].isSetupViewportOverlays) {
              //四角标注
              _this.setupViewportOverlays(0)
              _this.imageViewports[0].isSetupViewportOverlays = true;
            }

            // 拼接 url : cornerstoneWADOImageLoader 需要 wadouri 路径头
            const imageUrl = _this.baseUrl+ _this.seriesLis.instances[seriesNum].dicomUrl;
            let imageId = "wadouri:" + imageUrl;

            //  下载图像并显示
            cornerstone.loadAndCacheImage(imageId).then(
              function (image) {
                // 设置元素视口
                let viewport = cornerstone.getDefaultViewportForImage(
                  _this.imageViewports[0].canvas,
                  image
                );
                // 激活工具(图像加载前)
                _this.initCanvasTools1(seriesNum, 0);
                // 显示图像
                cornerstone.displayImage(_this.imageViewports[0].canvas, image, viewport);
                // 激活工具(图像加载后)
                _this.initCanvasTools2(seriesNum, 0);
                // _this.restore();
                // 图像是否加载完成
                if (!_this.imageViewports[0].isLoadAndCacheImage) {

                  _this.imageViewports[0].isLoadAndCacheImage = true;
                   _this.restore();
                }

              },
              function (err) {
                console.log('%c '+err,'color:red');
              }
            );
        })
        // Dicom 加载 进度
        cornerstone.events.addEventListener(
          "cornerstoneimageloadprogress",
          function (event) {
            const eventData = event.detail;
            const loadProgress = document.getElementById("loadProgress");
			console.log('家在进度')
			console.log(eventData)
          }
        );
      },
      // Window Resize 监听窗口改变
      listenForWindowResize() {
        
        this.$nextTick(function () {
          window.addEventListener(
            "resize",
            this.debounce(this.onWindowResize, 100)
          );
        });
      },
      // 重新加载绘图区域大小
      onWindowResize() {
        for (var i = 0; i < this.imageViewports.length; i++) {
          if(this.imageViewports[i].isLoadAndCacheImage){
            cornerstone.resize(this.imageViewports[i].canvas, true);
          }
        }
      },
      // Utility Methods (工具实用方法？？)
      debounce(func, wait, immediate) {
        console.log('窗口变化了')
        var timeout;
        return function () {
          var context = this;
          var args = arguments;
          var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      },
      // DICOM阅片
      forEachViewport(callback) {
        for (var i = 0; i < this.imageViewports.length; i++) {
          if(this.imageViewports[i].isLoadAndCacheImage){
            try {
              callback(this.imageViewports[i].canvas);
            }
            catch (e) {
              console.log("Debug:" + i)
              console.info(e);
            }
          }
        }
      },
      //布局 1x1\1x2\1x3...(根据选项，重新布局大图页面)
      changeLayout() {
        var that = this;
        var s = this.layoutVal.split(/x/);
        var ab = [parseInt(s[0]), parseInt(s[1])], a = ab[0], b = ab[1], numOfViewports = a * b,perWidth = 100 / b, perHeight = 100 / a;
        console.log(numOfViewports)
        //数组增
        if(numOfViewports>this.imageViewports.length){
          for(var i=this.imageViewports.length;i<numOfViewports;i++){
            var obj={
              isShow: false,
              isEnable: false,
              isSetupViewportOverlays: false,
              isLoadAndCacheImage: false
            }
            this.imageViewports.push(obj)
          }
        }
        //数组减
        else if(numOfViewports<this.imageViewports.length){
          this.imageViewports=this.imageViewports.slice(0,numOfViewports);
        }
        console.log(this.imageViewports)
        //重新布局(改变每个大图框的大小)
        this.viewportWrapperWidth = perWidth;
        this.viewportWrapperHeight = perHeight;
        this.$nextTick(() => {
          //目前因为 使用 v-if 是否展示viewport，所以viewport第一次会不加载
          // var elementsByClassName = document.getElementsByClassName("viewport");
          // for (var i = 0; i < elementsByClassName.length; i++) {
          //   cornerstone.enable(elementsByClassName[i]);
          // }
          that.onWindowResize();
        })
      },
      // 四角标注
      setupViewportOverlays(num) {
        var _this = this;

        // On new image (displayed?)
        function onNewImage(event) {
          const eventData = event.detail;
          // CT mA - kV
          switch (eventData.image.data.string("x00080060")) {

            case "CT":

              var mA = eventData.image.data.string("x00181151");
              var kV = eventData.image.data.string("x00180060");
              var cH = eventData.image.data.string("x00180050");//获取层厚 （还需确认这个值是否是层厚）

              if (mA !== undefined && mA !== null && mA !== "") {
                // $(bottomRightSpan[0]).html(eventData.image.data.string("x00181151")+"mA");
                // console.log(eventData.image.data.string("x00181151") + "mA");
                _this.imageViewports[num].x00181151=eventData.image.data.string("x00181151") + "mA";
              } else {
                _this.imageViewports[num].x00181151="";
              }
              if (kV !== undefined && kV !== null && kV !== "") {
                // $(bottomRightSpan[1]).html(eventData.image.data.string("x00180060")+"kV");
                // console.log(eventData.image.data.string("x00180060") + "kV");
                _this.imageViewports[num].x00180060=eventData.image.data.string("x00180060") + "kV";
              } else {
                // $(bottomRightSpan[1]).html("");
                _this.imageViewports[num].x00180060="";
              }
              if (cH !== undefined && cH !== null && cH !== "") {
                // console.log(eventData.image.data.string("x00180050") + "层厚");
                _this.imageViewports[num].x00180050=eventData.image.data.string("x00180050") + "层厚";
              } else {
                _this.imageViewports[num].x00180050="";
              }

              break;
            default :
              break;
          }

          // If we are currently playing a clip then update the FPS
          // Get the state of the 'playClip tool'
          var playClipToolData = cornerstoneTools.getToolState(eventData.element, 'playClip');

          // If playing a clip ...
          if (playClipToolData !== undefined && playClipToolData.data.length > 0 && playClipToolData.data[0].intervalId !== undefined && eventData.frameRate !== undefined) {

            // Update FPS
            // $(bottomLeft[0]).text("FPS: " + Math.round(eventData.frameRate));
            console.log("FPS: " + Math.round(eventData.frameRate));
            _this.imageViewports[num].FPS="FPS: " + Math.round(eventData.frameRate);

          } else {
            // Set FPS empty if not playing a clip
            // if ($(bottomLeft[0]).text().length > 0) {
            //   $(bottomLeft[0]).text("");
            // }
            if(_this.imageViewports[num].FPS&&_this.imageViewports[num].FPS.length > 0){
              _this.imageViewports[num].FPS=""
            }
          }

          var toolData = cornerstoneTools.getToolState(eventData.element, 'stack');
          if (toolData === undefined || toolData.data === undefined || toolData.data.length === 0) {
            return;
          }
          var stack = toolData.data[0];

          // Update Image number overlay
          // $(bottomLeft[2]).text("Image # " + (stack.currentImageIdIndex + 1) + "/" + stack.imageIds.length);
          // console.log("Image # " + (stack.currentImageIdIndex + 1) + "/" + stack.imageIds.length);

          _this.imageViewports[num].Image="Image # " + (stack.currentImageIdIndex + 1) + "/" + stack.imageIds.length;

          //重新渲染页面
          _this.$forceUpdate();
        }

        // Add a CornerstoneNewImage event listener on the 'element' (viewer) (?)
        // element.onCornerstoneNewImage=onNewImage;
        // 图像初始化事件
        _this.imageViewports[num].canvas.addEventListener(
          "cornerstonenewimage",
          onNewImage)

        // On image rendered
        function onImageRendered(event) {
          const eventData = event.detail;
          // Set zoom overlay text
          // $(bottomRight[0]).text("Zoom:" + eventData.viewport.scale.toFixed(2));

          // console.log("Zoom:" + eventData.viewport.scale.toFixed(2));
          _this.imageViewports[num].Zoom="Zoom:" + eventData.viewport.scale.toFixed(2);
          // Set WW/WL overlay text
          // $(bottomRight[1]).text("WW/WL:" + Math.round(eventData.viewport.voi.windowWidth) + "/" + Math.round(eventData.viewport.voi.windowCenter));
          // console.log("WW/WL:" + Math.round(eventData.viewport.voi.windowWidth) + "/" + Math.round(eventData.viewport.voi.windowCenter));
          _this.imageViewports[num].WWWL="WW/WL:" + Math.round(eventData.viewport.voi.windowWidth) + "/" + Math.round(eventData.viewport.voi.windowCenter);
          // Set render time overlay text
          // $(bottomLeft[1]).text("Render Time:" + eventData.renderTimeInMs + " ms");
          // console.log("Render Time:" + eventData.renderTimeInMs + " ms");
          _this.imageViewports[num].RenderTime = "Render Time:" + eventData.renderTimeInMs + " ms";
          //重新渲染页面
          _this.$forceUpdate();
        }

        // Add a CornerstoneImageRendered event listener on the 'element' (viewer) (?)
        // element.onCornerstoneImageRendered=onImageRendered;
        // 图像改变事件
        _this.imageViewports[num].canvas.addEventListener(
          "cornerstoneimagerendered",
          onImageRendered)
      },
    }
  }
</script>

<style>
  @import "../../../static/css/cornerstone.min.css";
  @import "../../../static/css/viewmulti.css";
  *{
    margin:0;
    padding:0
  }
  #wrap{
    background-color: #000;
  }
  .image-canvas-wrapper {
    width: 100%;
    height: 80vh;
    margin: 0 auto;
  }

  .image-canvas {
    width: 100%;
    height: 100%;
  }

  .csthumbnai {
    color: white;
    background-color: black;
    width: 100px;
    height: 100px;
    outline: 1px solid rgb(156, 153, 153);
    padding: 0px;
    margin:5px;
  }

  .viewportWrapper {
    position: relative;
    color: white;
    display: inline-block;
    background-color: black;
    background-color: rgba(14, 12, 12, 0.28)
  }
  .setupViewportOverlays{
    position:absolute;
    color: #e4ad00;
    font-size:5%;
  }
  .selected{
    outline: 1px solid #e4ad00;
  }
  .bigImgBox{
    box-sizing: border-box;
  }
  .smallImgBox{
    width:100px;
    height:100px;
    border:1px solid #e4ad00;
    position: absolute;
    z-index: 100;
  }
  .backColor{
    background-color:#000;
  }
  .btnBox{
    display: flex;
    justify-content: flex-start;
    flex-wrap:wrap;
  }
  .btnBox .list{
    background-color: #333333;
    border-radius: 8px;
    padding:10px;
    margin:5px 0;
    margin-left:5px;
    display: flex;
    justify-content: flex-start;
  }
  .btnBox .list .buttonP{
    color:#fff;
    margin-left:5px;
    cursor: pointer;
    font-size: 14px;
    text-align: center;
    width:60px;
  }
  .btnBox .list .buttonSelect{
    color:#000;
    margin-left:5px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 6px;
    outline: none;
  }
  .btnBox .list .button{
    color:#fff;
    margin-left:5px;
    font-size: 15px;
    outline: none;
  }
  .btnBox .list .buttonP:hover{
    color:#e4ad00;
  }
  .imgStyle{
    width:40px;
    height:40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Viewm/Viewm.vue